export default __webpack_public_path__ + "static/media/force.ff69f781.svg";